import React from 'react';
import { Button } from '@mui/material';
import { Close, Publish } from '@mui/icons-material';
import { GVTypography } from 'components/lib';
import GVIconButton from 'components/lib/GVIconButton/GVIconButton';
import { useField, useFormikContext } from 'formik';
import { makeStyles } from 'tss-react/mui';
import styles from './UploadCertificate.module.css';

const useStyles = makeStyles()(() => ({
  uploadButton: {
    height: '36px',
    minWidth: '159px',
  },
}));

interface UploadCertificateProps {
  name: string;
  disabled: boolean;
}

const UploadCertificate = (props: UploadCertificateProps) => {
  const { classes } = useStyles();
  const [inputValue, setInputValue] = React.useState('');
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props.name);

  const handleUpload = (e: any) => {
    const file = e.target.files[0];
    setFieldValue(props.name, file);
  };

  return (
    <>
      <Button
        className={classes.uploadButton}
        color="secondary"
        component="label"
        startIcon={<Publish />}
        variant="contained"
        id="user-save-button"
        data-testid="user_save_changes"
        disabled={props.disabled}
      >
        Upload Certificate
        <input type="file" value={inputValue} accept=".pem, .cer, .crt" hidden onChange={handleUpload} />
      </Button>
      <div className={styles.label}>
        {field.value ? (
          <GVTypography className={styles.name} noWrap>
            {field.value.name}
          </GVTypography>
        ) : (
          <GVTypography>No file selected</GVTypography>
        )}
        {field.value && (
          <GVIconButton
            icon={
              <Close
                fontSize="small"
                color="primary"
                onClick={() => {
                  setInputValue('');
                  setFieldValue(props.name, '');
                }}
              />
            }
          />
        )}
      </div>
    </>
  );
};

export default UploadCertificate;
